const moduleName = 'headHint';

export function headHint() {
	var btnIn = $('.js-btn-in');
	var btnOut = $('.js-btn-out');
	function hideHeadhint(){
		var hintParent = $(".hint-parent");
		$('.hint').remove();
		//setTimeout(function(){
		  hintParent.removeClass("with-hint");
		//}, 500);
		$('.header__dropdown-envelope').removeClass('active');
	}

	function setCookie(key, value, expiry) {
        var expires = new Date();
        expires.setTime(expires.getTime() + (expiry * 24 * 60 * 60 * 1000));
        document.cookie = key + '=' + value + ';expires=' + expires.toUTCString();
    }

	$('.header__dropdown.hint-parent').click(function(event){
		if ( $(event.target).hasClass('js-btn-in') /*|| $(event.target).hasClass('js-btn-out')*/){
			return false;
		}
		if ($(this).closest('.header__dropdown-envelope').find('.dropdown__list.hint').length > 0){
			return false;
		}
		if ($(this).closest('.header__dropdown-envelope').find('.dropdown__list._inner__list').css('opacity') == 1){
			$(this).closest('.header__dropdown-envelope').addClass('hide_dropdown');
			$(this).closest('.header__dropdown-envelope').removeClass('active');
			$('html').removeClass('hint-open');
			return false;
		}else{
			$(this).closest('.header__dropdown-envelope').removeClass('hide_dropdown');
			$(this).closest('.header__dropdown-envelope').addClass('active');
			$('html').addClass('hint-open');
		}
	})

	$('.header__dropdown-envelope .dropdown__list-link').click(function(){
		var textVal = $(this).attr('data-value');
		$('.header__dropdown.hint-parent > span').text(textVal);
	});

	$(document).mouseup(function(e) {
	    var container = $(".header__dropdown-envelope");
	    if (!container.is(e.target) && container.has(e.target).length === 0) 
	    {
	        $('.header__dropdown-envelope').removeClass('active');
	        $('html').removeClass('hint-open');
	    }
	});

	if ( btnIn ) {
		btnIn.on('click', () => {
			hideHeadhint();
			setCookie('region_hint','1','80');
		});
	}
	if ( btnOut ) {
		btnOut.on('click', () => {
			hideHeadhint();
		});
	}

	$(document).on('click', () => {
		
		/*var checkOpacity = 0;
		$('.header__dropdown.hint-parent .dropdown__list._inner__list:visible').each(function(){
			if ( $(this).css('opacity') == 1 ){
				checkOpacity = 1;
			}
		})
		if (checkOpacity == 1){
			$('html').addClass('hint-open');
		}else{
			$('html').removeClass('hint-open');
		}*/
	});
	
	
}